import { awards, supports } from "../data";
import { ArrowLink, PageIntro } from "../components/Shell";
import { TimelineList } from "../components/Records";

export default function NewsPage() {
  return (
    <>
      <PageIntro
        label="Activities"
        title="수상과 활동"
        aside={
          <>
            수상 기록 · {awards.length}
            <br />
            연도 역순
          </>
        }
      />
      <section className="page-section shell" aria-labelledby="awards-heading">
        <div className="section-header">
          <div>
            <p className="section-label">Recognition</p>
            <h2 id="awards-heading">수상</h2>
          </div>
          <ArrowLink to="/projects">연구 지원 {supports.length}건</ArrowLink>
        </div>
        <TimelineList records={awards} headingLevel={2} />
      </section>
    </>
  );
}
